import { SegmentedControl } from "@abb/arcadia-ui-react"
import { useCallback, useEffect, useState } from "react"

export function ThemeSwitch() {
  const [theme, setTheme] = useState<"light" | "dark">("light")

  useEffect(() => {
    const prefersDark = globalThis.matchMedia?.("(prefers-color-scheme: dark)")?.matches
    setTheme(prefersDark ? "dark" : "light")
  }, [])

  useEffect(() => {
    document.documentElement.dataset.theme = theme
  }, [theme])

  const handleThemeChange = useCallback((id: string) => {
    setTheme(id === "light" ? "light" : "dark")
  }, [])

  return (
    <SegmentedControl
      key={theme}
      hightlightColor="white"
      onClick={handleThemeChange}
      segmentedControlItems={[
        { iconName: "icon-abb_light icon_abb_dias", id: "light" },
        { iconName: "icon-abb_dark icon_abb_dias", id: "dark" },
      ]}
      defaultSelected={theme}
      size={32}
    />
  )
}
